export default __webpack_public_path__ + "static/enrique-avatar-ab2f36b8994d6678be075a0bc541602c.webp";